<template>
  <PeriodeForm mode="Tambah" module="Periode"> </PeriodeForm>
</template>

<script>
import PeriodeForm from './form';

const PeriodeAdd = {
  name: 'PeriodeAdd',
  components: { PeriodeForm },
};

export default PeriodeAdd;
</script>
